import { styles as componentStyles } from './view.scss';
import { styles as styleHelpers } from '../../../../../../../../assets/style-helpers.scss';
import { unsafeCSS } from 'lit';

export const styles = [unsafeCSS(`${styleHelpers}`), unsafeCSS(`${componentStyles}`)];
